import { render, staticRenderFns } from "./JZoneList.vue?vue&type=template&id=48c418e3"
import script from "./JZoneList.vue?vue&type=script&lang=js"
export * from "./JZoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports